import * as types from '@/store/mutation-types';

const getters = {
  isBack: state => state.isBack,
  lastShaftTab: state => state.lastShaftTab,
};

const actions = {
  setIsBack({ commit }, isBack) {
    commit(types.SET_IS_BACK, isBack);
  },
  setLastShaftTab({ commit }, shaftTab) {
    commit(types.SET_LAST_SHAFT_TAB, shaftTab);
  },
};

const mutations = {
  [types.SET_IS_BACK](state, isBack) {
    state.isBack = isBack;
  },
  [types.SET_LAST_SHAFT_TAB](state, shaftTab) {
    state.lastShaftTab = shaftTab;
  },
};

const state = {
  isBack: false,
  lastShaftTab: 0,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
